<template>
    <div class="newsIndex">
        <div class="newsIndex-content" >
            <div class="newsIndex-content-left" v-if="model === 'column2'">
                <div class="newsNav" >
                    <div class="newsNav-name">{{navs[0] && navs[0].columnName}}</div>
                </div>
                <div class="content" v-loading="leftLoading">
                    <NoData v-if="leftModuleList.length === 0 && !leftLoading && !firstMount"/>
                    <div v-for="(item,index) in leftModuleList" :key = "index" >
                        <NewItem :data="item" :mode="index < 3 ? 'pic':'normal'"/>
                    </div>
                </div>
            </div>
            <div class="newsIndex-content-right" :class="[{column1:model === 'column1'}]"  >
                <div class="newsNav">
                    <div class="active-bar" :style="{left: cursorPosition + 'px', width: currentItemWidth + 'px'}" v-if="navs.length > 0"></div>
                    <div class="newsNav-li"  :ref="item.id" v-for="(item,navindex) in (navs.slice(moreIndexStart,moreIndexEnd))" :key="navindex" @click="changeNav(navindex,item)">
                        <div class="newsNav-li-name" >
                            {{item && item.columnName}}
                        </div><i v-if="navindex !== (navs.slice(moreIndexStart,moreIndexEnd).length -1) || navs.length > moreIndexEnd">/</i>
                    </div>
                    <div class="newsMore" >
                        <el-dropdown class="dropdown" v-if="this.navs.length > moreIndexEnd" trigger="click" @command="changeNav1">
                <span class="el-dropdown-link" >
    更多<i class="el-icon-arrow-down el-icon--right"></i>
  </span>
                            <el-dropdown-menu slot="dropdown" >
                                <el-dropdown-item v-for="(item,index) in navs.slice(moreIndexEnd)" :key="index" :command="index" >{{item && item.columnName}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
                <div class="content" v-loading="loading || leftLoading" :style="{display: newsList.length === 0 ? 'block' : 'flex' }">
                    <NoData v-if="newsList.length === 0 && !loading && !leftLoading && !firstMount"/>
                    <div class="content-left" :class="[{column2:model !== 'column1'}]">
                        <div v-for="(item,index) in (model === 'column1' ? leftNewsList : newsList)" :key="index" >
                            <NewItem :data="item" :mode="index < 3 ? 'pic':'normal'"/>
                        </div>
                    </div>
                    <div class="content-right" v-if="model === 'column1'">
                        <div v-for="(item,index) in rightNewsList" :key="index">
                            <NewItem :data="item" :mode="index < 3 ? 'pic':'normal'"/>
                        </div>

                    </div>
                    <!--                <div v-for="(item,index) in newsList" :key="index">-->
                    <!--                <NewItem :data="item"/>-->
                    <!--                </div>-->

                </div>
            </div>

        </div>
        <div class="newsIndex-bottom">
            <el-button round @click="newsJump" v-if="newsList.length !== 0"><svg-icon icon="squre"></svg-icon>全部资讯</el-button>
        </div>
        <div class="change-model" @click="changeModel" >
            <img class="change-model" :src="require('@/assets/Home/Index/NewsIndex/changeModel.png')"/>
        </div>
        <div class="setting" >
            <el-dropdown trigger="click">
                <span class="el-dropdown-link" >
                    <i class="el-icon-setting"></i>
                    </span>
                <el-dropdown-menu slot="dropdown" >
                    <div style="color: red;font-size: 12px">*勾选后的栏目将显示在首页</div>
                    <el-checkbox-group v-model="checkListChoosed" @change="getCheckList" :min="2">
                        <el-checkbox v-for="item in checkList" :label="item.id" :key="item.id">{{item && item.columnName}}</el-checkbox>
                    </el-checkbox-group>
                </el-dropdown-menu>
            </el-dropdown>
        </div>

    </div>

</template>

<script>
    import NewItem from "./NewsIndex/NewItem";
    import { getNewsColumn, getNewsList, getNewsContent, getRssContent } from "@/api/news";
    import {mapGetters} from "vuex";
    import NoData from '@/views/NewsNew/noData.vue';
    import { getRecordPreviewHistory,setRecordPreviewHistory } from '@/api/user.js'
    import { ifNewVisit } from '@/utils/utils.js'
    export default {
        name: "NewsIndex",
        data(){
            return {
                model: 'column2',
                active: 0,
                checkList:[],
                checkListChoosed:[],
              choosedIds:'',
                choosedColumn:{},
                navs:[],
                newsList:[
                ],
                leftModuleList:[
                ],
              rightModuleList:[
              ],
              rightModule:false,
                loading:false,
                leftLoading:false,
                moreIndexStart:0,
                moreIndexEnd:4,
                cursorPosition:0,
                currentItemWidth:0,
                leftNewsList:[],
                rightNewsList: [],
                height:0,
              firstMount: true

            }
        },
      async created(){
            await this.getRecordPreviewHistory();

        // column1 -- 单栏 column2 -- 双栏
            if(this.model === 'column1') {
              this.loading = true
            } else {
              this.loading = true
              this.leftLoading = true;
            }


        },
      mounted(){
        window.onresize = ()=> {
          let model;
          if(this.model === 'column1') {
            model = 'model1';
          }else{
            model = 'model2';
          }
          this.moreIndexEnd = this.getMoreIndexEnd(model);
        }
      },
        updated(){
            let offsetLeft;
            let offsetWidth
            if(this.model === 'column1') {
                offsetLeft = this.navs[this.active] && this.$refs[this.navs[this.active].id][0].offsetLeft;
                offsetWidth = this.navs[this.active] && this.$refs[this.navs[this.active].id][0].offsetWidth;

            }
            if(this.model === 'column2') {
                offsetLeft = this.navs[this.active] && this.$refs[this.navs.slice(this.moreIndexStart,this.moreIndexEnd)[this.active].id][0].offsetLeft
                offsetWidth = this.navs[this.active] && this.$refs[this.navs.slice(this.moreIndexStart,this.moreIndexEnd)[this.active].id][0].offsetWidth;
            }
            this.cursorPosition = offsetLeft + 0.1*offsetWidth;
            this.currentItemWidth = 0.7*offsetWidth;
        },
        computed: {
            ...mapGetters(["serveUrl", "request"]),
        },
        components: {
            NewItem,
            NoData
        },
        watch:{
           async model(val){
                if(val === 'column1') {
                  this.modelColumn1();
                }
                if(val === 'column2') {
                  this.modelColumn2();

                }
            },
            newsList(){
                this.handleNewsList()
            }
        },
        methods: {
          modelColumn1(){
            this.moreIndexStart = 0;
            this.moreIndexEnd = this.getMoreIndexEnd('model1');
            this.active = 0;
            this.choosedColumn = this.navs[this.active];
            this.getAllKindNewsList(this.navs[this.active],'newsList');
          },
          modelColumn2(){
            this.height = 0;
            this.newsList = [];
            this.loading = true
            this.rightModule = false;
            this.moreIndexStart = 1;
            this.moreIndexEnd = this.getMoreIndexEnd('model2');
            this.active = 0;
            this.choosedColumn = this.navs[this.active+1];
            Promise.all([this.getAllKindNewsList(this.navs[0],'leftModuleList'),this.getAllKindNewsList(this.navs[this.active+1],'newsList')]).then(values => {
              let heightpp = 0;
              let newsList = [];
              // 模式二如果左边模块数据少于14，右边模块直接取14条数据；如果左边模块数据多于14，右边模块直接按照左边模块高度计算数据数量
              if(this.leftModuleList.length < 14 ) {
                let newsListTemp = [];
                let heightTotal = 0
                this.rightModuleList.forEach(newsItem=> {
                  // debugger;
                  heightTotal += newsItem.heightpp;
                  if(heightTotal*64 <= 896){
                    newsListTemp.push(newsItem)
                  }
                })
                this.newsList = newsListTemp;
              } else {
                this.rightModuleList.forEach( (item) => {
                  if(this.height > heightpp) {
                    newsList.push(item)
                    heightpp += item.heightpp;
                  }
                })
                this.newsList = newsList;
              }
              this.rightModule = true;
            })
          },
            handleNewsList(){
                let newsList = this.newsList;
                let leftNewsList = [];
                let rightNewsList = [];
                let left = 0;
                let right = 0;
                newsList.forEach( (newsItem,newIndex) => {
                   if(left <=right) {
                       if(newsItem.titleImage && leftNewsList.length < 3  ) {
                           newsItem.heightrr = 3
                       }else{
                           newsItem.heightrr = 1
                       }
                       // 896 为最大内容高度，64为单元高度
                       if(left*64 < 896){
                         leftNewsList.push(newsItem)
                         left += newsItem.heightrr;
                       }

                   }else{
                       if(newsItem.titleImage && rightNewsList.length < 3  ) {
                           newsItem.heightrr = 3
                       }else{
                           newsItem.heightrr = 1
                       }
                     if(right*64 < 896){
                       rightNewsList.push(newsItem)
                       right += newsItem.heightrr;
                     }


                   }
                })
                this.leftNewsList = leftNewsList;
                this.rightNewsList = rightNewsList;
            },
            async getRecordPreviewHistory(){
                try{
                    let res = await getRecordPreviewHistory();
                  this.firstMount = false;
                    if(res.code !== 0) {
                        this.getNewsColumn();
                        return;
                    }
                  if(!res.data.cmsContentRecord || res.data.cmsContentRecord === ' ') {
                    this.model = 'column2';
                  } else{
                    this.model = res.data.cmsContentRecord;
                  }


                    if(!res.data.cmsListRecord || res.data.cmsListRecord === ' ') {
                        this.getNewsColumn();
                        return;
                    }
                    let cmsListRecord = res.data.cmsListRecord;
                    this.getNewsColumn(cmsListRecord.split(','));
                    //  this.dataSortSetting = res.data.cmsListRecord ? res.data.cmsListRecord : [];
                    // let mediaArr = [];
                    // this.dataSortSetting.forEach( dataType => {
                    //     this.hotData.forEach ( dataItem => {
                    //         if(dataType === dataItem.dataType) mediaArr.push(dataItem);
                    //     })
                    // })
                    // this.hotData = mediaArr;
                    // console.log('res.data.personalData', res.data.cmsListRecord);

                }catch(e){
                  this.firstMount = false;
                    this.getNewsColumn();
                    return;
                }
            },
            getMoreIndexEnd(model){

                let screenWidth = document.documentElement.clientWidth;
                if(model === 'model1') {
                    if(screenWidth >= 1719) {
                        return 10
                    } else if (screenWidth < 1719 && screenWidth >= 1300) {
                        return 7;
                    } else {
                        return 4;
                    }
                }
                if(model === 'model2') {
                    if(screenWidth >= 1719) {
                        return 5
                    } else if (screenWidth < 1719 && screenWidth >= 1300) {
                        return 4;
                    } else {
                        return 2;
                    }
                }
            },
            newsJump(){
                this.$router.push({name:"NewsCenter"})
            },
            changeModel(){
                this.model = this.model === 'column1' ? 'column2' : 'column1';
              this.setRecordPreviewHistory(this.choosedIds, this.model);
            },
            changeNav(index,item){
                if(this.choosedColumn.id === item.id) {
                    return false;
                }
                this.active = index;
                this.choosedColumn = item;
                this.getAllKindNewsList(item,'newsList');
            },
            changeNav1(index){
                this.active = this.moreIndexEnd - this.moreIndexStart - 1;
                // this.choosedColumn = this.navs[index];
                // this.getAllKindNewsList(this.navs[index],'newsList');
                let len = this.moreIndexEnd;
                let obj = this.navs[len-1];
                let item = this.navs[len+index];
                this.choosedColumn = item;
                this.getAllKindNewsList(item,'newsList');
                this.navs.splice(len-1,1,item)
                this.navs.splice(len+index,1,obj);
            },
            getCheckList(choosedIds){
            console.log('777',choosedIds)
            this.choosedIds = choosedIds;
                this.setRecordPreviewHistory(choosedIds);
                this.active = 0;
                let arr = [];
                this.checkList.forEach( columnItem => {
                    choosedIds.forEach( columnId => {
                        if(columnItem.id === columnId) {
                            arr.push(columnItem)
                        }
                    })
                })
                this.navs = arr;


                if(this.model === 'column1') {
                    this.choosedColumn = this.navs[this.active];
                    this.getAllKindNewsList(this.navs[this.active],'newsList');
                }else {
                    this.choosedColumn = this.navs[1];
                    this.getAllKindNewsList(this.navs[0],'leftModuleList');
                    this.getAllKindNewsList(this.navs[1],'newsList');
                }
            },
            setRecordPreviewHistory(choosedIds,model){
              model= model||'';
                let param = {cmsListRecord:choosedIds,cmsContentRecord:model};
                setRecordPreviewHistory(param);
            },
            // 获取新闻栏目
            async getNewsColumn(userRecond){
                try{
                    let data = {
                        request: this.request,
                        serveUrl: this.serveUrl,
                        header: "portal"
                    };
                    let res = await getNewsColumn(data);
                    if(res.code !== 0) {
                        this.$message.error('请求新闻栏目错误!');
                        return;
                    }
                    this.checkList = JSON.parse(JSON.stringify(res.data));
                    if(userRecond && userRecond.length > 0 ) {
                        let arr = [];
                        this.checkList.forEach( columnItem => {
                            userRecond.forEach( columnId => {
                                if(columnItem.id === columnId) {
                                    arr.push(columnItem)
                                }
                            })
                        })
                        this.navs = arr;
                    } else {
                        this.navs = res.data || [];
                    }

                    this.navs.forEach( item => {this.checkListChoosed.push(item.id)});
                  if(this.model === 'column1') {
                    this.modelColumn1();
                  }else{
                    this.modelColumn2();
                  }


                }catch(e){
                    this.$message.error('请求新闻栏目错误!');
                }

            },
            async getAllKindNewsList(columnData,dataAccepter){

                if(dataAccepter === 'leftModuleList') {
                    this.leftLoading = true;
                } else {
                  this.loading = true;
                }

                this[dataAccepter] = [];
                if(columnData && columnData.rss) {
                    await this.getRssContent(columnData,dataAccepter);
                } else {
                    await this.getNewsList(columnData,dataAccepter);
                }
            },
            async getNewsList(currentCategory,dataAccepter){
                try{
                    let data = {
                        request: this.request,
                        serveUrl: this.serveUrl,
                        ColumnId: currentCategory.id || "",
                        kw: "",
                        pageNo: 1,
                        pageSize: 30,
                        loadContent: false,
                        header: "portal",
                        loadPicContents: false
                    };
                    let res = await getNewsList(data);



                    if(dataAccepter === 'leftModuleList') {
                      this.leftLoading = false
                    }else{
                      this.loading = false;
                    }


                    if(res.code !== 0) {
                        this.$message.error('请求新闻列表错误!');
                        return;
                    }
                    let allContents = res.data.allContents;

                    allContents.forEach( (item,index) => {
                        if(item.titleImage && index < 3  ) {
                            item.heightpp = 3
                        }else{
                            item.heightpp = 1
                        }
                        item.isNewNews = ifNewVisit(item.releaseStartTime,new Date().getTime(), 3*24*60*60*1000);
                      item.releaseStartTime = item.releaseStartTime && item.releaseStartTime.replace(/-/g, '/') || '';
                    })
                    if(dataAccepter === 'leftModuleList') {
                            this.leftModuleList = allContents.slice(0,14) || [];
                        this.leftModuleList.forEach( item => {
                            this.height +=item.heightpp;
                        })

                    }else {
                        if(allContents && allContents.length === 0 ||  allContents.length > 0 && allContents[0].columnId === this.choosedColumn.id) {
                            if(this.model === 'column1'){
                                this.newsList = allContents.slice(0,28) || [];

                            }else{
                                // this.newsList = allContents.slice(0,14) || [];

                              if(this.rightModule) {
                                if(this.leftModuleList.length < 14) {
                                  let newsListTemp = [];
                                  let heightTotal = 0
                                  allContents.forEach(newsItem=> {
                                    heightTotal += newsItem.heightpp;
                                    if(heightTotal*64 <= 896){
                                      newsListTemp.push(newsItem)
                                    }
                                  })
                                  this.newsList = newsListTemp;
                                } else {
                                  let heightpp = 0;
                                  let newsList = [];
                                  allContents.forEach( (item) => {
                                    if(this.height > heightpp) {
                                      newsList.push(item)
                                      heightpp += item.heightpp;
                                    }
                                  })
                                  this.newsList = newsList;
                                }
                              }else {
                                this.rightModuleList =  allContents;
                              }

                            }
                        }
                    }
                }catch(e){
                    // this.$message.error('请求新闻列表错误!');

                }
                this.loading = false;

            },
            async getRssContent(currentCategory,dataAccepter){
                try{
                    let data = {
                        request: this.request,
                        serveUrl: this.serveUrl,
                        header:"portal",
                        ColumnId: currentCategory.id || "",
                        pageNo: 1,
                        pageSize: 30,
                    };
                    let res = await getRssContent(data);
                    if(dataAccepter === 'leftModuleList') {
                        this.leftLoading = false
                    }
                    this.loading = false;
                    if(res.code !== 0) {
                        this.$message.error('请求新闻列表错误!');
                        return;
                    }
                  let allContents = res.data.allContents;
                  allContents.forEach( (item,index) => {
                    if(item.titleImage && index < 3  ) {
                      item.heightpp = 3
                    }else{
                      item.heightpp = 1
                    }
                    item.isNewNews = ifNewVisit(item.releaseStartTime,new Date().getTime(), 3*24*60*60*1000);
                    item.releaseStartTime = item.releaseStartTime && item.releaseStartTime.replace(/-/g, '/') || '';
                  })
                  if(dataAccepter === 'leftModuleList') {
                    this.leftModuleList = allContents.slice(0,14) || [];
                    this.leftModuleList.forEach( item => {
                      this.height +=item.heightpp;
                    })

                  }else {
                    if(allContents && allContents.length === 0 ||  allContents.length > 0 && allContents[0].columnId === this.choosedColumn.id) {
                      if(this.model === 'column1'){
                        this.newsList = allContents.slice(0,28) || [];

                      }else{
                        // this.newsList = allContents.slice(0,14) || [];

                        if(this.rightModule) {
                          if(this.leftModuleList.length < 14) {
                            let newsListTemp = [];
                            let heightTotal = 0
                            allContents.forEach(newsItem=> {
                              heightTotal += newsItem.heightpp;
                              if(heightTotal*64 <= 896){
                                newsListTemp.push(newsItem)
                              }
                            })
                            this.newsList = newsListTemp;
                          } else {
                            let heightpp = 0;
                            let newsList = [];
                            allContents.forEach( (item) => {
                              if(this.height > heightpp) {
                                newsList.push(item)
                                heightpp += item.heightpp;
                              }
                            })
                            this.newsList = newsList;
                          }

                        }else {
                          this.rightModuleList =  allContents;
                        }

                      }
                    }
                  }

                }catch(e){
                    this.$message.error('请求新闻列表错误!');
                    return;
                }
                this.loading = false;


            },
        }
    }
</script>

<style scoped lang="scss">
    @import '@/styles/variables.scss';
    .newsIndex {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        position: relative;
        background-color: white;
        display: flex;
        flex-direction: column;
        .newsNav {
            height: 68px;
            padding-left: 10px;
            padding-right: 10px;
            border-bottom: 4px solid #f6f6f6;
          line-height: 64px;

            display: flex;
          &-li {
            line-height: 64px;
            height: 64px;
          }
        }
        &-bottom {
            width: 100%;
            cursor: pointer;
            font-size: 22px;
            text-align: center;
            padding-bottom: 31px;

            .el-button.is-round {
                padding: 10px 21px;
                margin-top: 10px;
                border-color: $color-primary;
                color:$color-primary;
                /deep/ span {
                    display: flex;
                    align-items: center;
                }
                svg {
                    margin-right: 6px;
                    width: 14px;
                    height: 14px;
                }
            }
        }
        &-content {
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            position: relative;
            background-color: white;
            overflow: hidden;
            display: flex;

            &-left{
                width: 50%;
                padding-left: 43px;
                padding-right: 17px;
                height: 100%;
                .newsNav {
                    &-name {
                        font-size: 16px;
                    }
                }
                .content {
                    margin-top: 18px;
                    min-height: 40%;
                  >div:last-child {
                    /deep/ .newItem  .content {
                      border: none;
                    }
                  }
                }

            }
            &-right{
                padding-left: 17px;
                padding-right: 43px;
                height: 100%;
                width: 50%;
                .newsNav {
                    position: relative;
                    &-li {
                        display: flex;
                        cursor: pointer;
                        &-name {
                            color: #333333;
                            font-size: 16px;
                            padding-left: 13px;
                            padding-right: 13px;
                            text-align: center;
                            min-width: 90px;
                        }
                        i {
                            color:#D3D3D3;
                        }

                    }
                    .active-bar {
                        position: absolute;
                        bottom: -4px;
                        left: 0;
                        height: 4px;
                        background-color: #F39800;
                        z-index: 1;
                        list-style: none;
                        width: 64px;
                        transition: 0.4s;
                    }
                    .newsMore {
                        height: 100%;
                        display: flex;
                        align-items: center;
                        .dropdown {
                            height: 20px;
                            line-height: 20px;
                          font-size: 16px;
                          .el-icon-arrow-down {
                            font-size: 14px;
                            font-weight: bold;
                          }

                        }
                    }
                }
                .content {
                    margin-top: 18px;
                    display: flex;
                    min-height: 40%;
                    &-left {
                        width: 50%;
                        padding-right: 17px;
                      >div:last-child {
                        /deep/ .newItem  .content {
                          border: none;
                        }
                      }
                    }
                    &-left.column2 {
                        width: 100%;
                        padding-right: 0;
                      >div:last-child {
                        /deep/ .newItem .content {
                          border: none;
                        }
                      }
                    }
                    &-right {
                        width: 50%;
                        padding-left: 17px;
                      >div:last-child {
                        /deep/ .newItem .content {
                          border: none;
                        }
                      }
                    }

                }
            }
            &-right.column1 {
                width: 100%;
                padding-left: 43px;

            }


        }


        .change-model {
            position: absolute;
            right: 0;
            top:0;
            cursor: pointer;
            img {
                width: 30px;
                height: 30px;
            }
        }
        .setting {
            position: absolute;
            right: 48px;
            top:21px;
            cursor: pointer;
            font-size: 22px;
            color: rgba(102, 102, 102, 1);
            .el-icon-setting {
                font-size: 22px;
            }


        }

    }
    .el-dropdown-link {
        cursor: pointer;
        color: #333333;
        padding-left: 13px;
    }
    .el-icon-arrow-down {
        font-size: 12px;
    }
    .el-dropdown-menu {
        padding: 14px 12px 14px 16px;
        color: #333333;
        font-size: 16px;
      max-height: 338px;
      overflow-y: auto;
        .el-checkbox {
            display: block;
            margin-top: 22px;
            &:nth-child(1) {
                margin-top: 16px;
            }
        }
    }


</style>